import { faTrophyStar } from "@fortawesome/pro-regular-svg-icons/faTrophyStar";
import { AccessKeys } from "app/appConstants";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AwardResume } from "views/award/Header/AwardResume";
import { HeaderLinkButton } from "./HeaderLinkButton";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const HeaderAward: React.FC = () => {
    const { t } = useTranslation("shared");
    const [open, setOpen] = useState<boolean>(false);

    ///
    function handleToggle() {
        setOpen(!open);
    }

    ///
    function handleClose() {
        setOpen(false);
    }

    ///
    return (
        <>
            <HeaderLinkButton
                accessKey={AccessKeys.Award}
                iconOrUrl={faTrophyStar}
                open={open}
                handleClose={handleClose}
                handleToggle={handleToggle}
                tooltip={t("App.Menu.Topbar.Award.Title")}
            >
                {open && <AwardResume onCloseMenu={handleClose} />}
            </HeaderLinkButton>
        </>
    );
};
